<template>
  <div class="chart-bar">
    <div class="chart-card">
      <div class="card-title">
        <div>广东省市场主体基本情况</div>
      </div>
      <div class="card-content">
        <div class="flex-between">
          <TabList :list="tabList" :act="tabIndex" @clickItem="changeTab" />
          <!-- @changeSelect="changeSelect" -->
          <ElementSelect
            :val="ztYyear"
            :options="ztYearList"
            @change="
              (e) => {
                ztYyear = e;
                getData();
              }
            "
          />
        </div>
        <el-carousel height="100%" :autoplay="false" style="width: 100%;height: 100%" arrow="never"
                     @change="carouselChange()">
          <el-carousel-item autoplay="false">
            <div class="card-item flex-between">
              <div class="item-wrapper">
                <div class="sub-title">
                  <span>基本概况</span>
                </div>
                <div class="wrapper flex-between l1-1" @click="openEntModal">
                  <div class="sum-box">
                    <div class="sum-i i1"></div>
                    <div class="sum-i i2"></div>
                    <div class="sum-i i3"></div>
                    <div class="sum-i i4"></div>
                    <div class="sum-img"></div>
                    <div class="sum-h1">民营经济市场主体总量</div>
                    <div class="sum-h2">
                      <b>{{ infoData.market_main_body_num }}</b
                      >{{ tabIndex ? '户' : '万户' }}
                    </div>
                  </div>
                  <div class="sum-list" style="display: flex;flex-direction: row">
                    <div class="list-item">
                      <div class="item-left item1">
                        <i class="i-img"></i>
                        <i v-if="tabIndex" :class="'i-trend' + (infoData.yoy_main_body > 0 ? ' up' : '')"></i>
                        <i v-else :class="'i-trend' + (infoData.ent_yoy > 0 ? ' up' : '')"></i>
                      </div>
                      <div class="item-right">
                        <h3>民营企业数量</h3>
                        <div class="middle-box">
                          <b>{{ tabIndex ? infoData.main_body_num : infoData.ent_num }}</b
                          >{{ tabIndex ? '户' : '万户' }}
                        </div>
                        <div v-if="tabIndex" :class="'bottom-box' + (infoData.yoy_main_body > 0 ? ' up' : '')">
                          {{ infoData.yoy_main_body > 0 ? ' 同比增长' : '同比下降' }}
                          <b>{{ infoData.yoy_main_body ? infoData.yoy_main_body.toFixed(2) + ' %' : '-' }} </b>
                        </div>
                        <div v-else :class="'bottom-box' + (infoData.ent_yoy > 0 ? ' up' : '')">
                          {{ infoData.ent_yoy > 0 ? ' 同比增长' : '同比下降' }}
                          <b>{{ infoData.ent_yoy ? infoData.ent_yoy.toFixed(2) + ' %' : '-' }} </b>
                        </div>
                      </div>
                    </div>
                    <div class="list-item" style="padding-top: 0px;
                    padding-left: 20px;margin-top: 0px">
                      <div class="item-left item2">
                        <i class="i-img"></i>
                        <i v-if="tabIndex" :class="'i-trend' + (infoData.yoy_individual_ent > 0 ? ' up' : '')"></i>
                        <i v-else :class="'i-trend' + (infoData.individual_ent_yoy > 0 ? ' up' : '')"></i>
                      </div>
                      <div class="item-right">
                        <h3>个体工商户数量</h3>
                        <div class="middle-box">
                          <b>{{ infoData.individual_ent_num }}</b
                          >{{ tabIndex ? '户' : '万户' }}
                        </div>
                        <div v-if="tabIndex" :class="'bottom-box' + (infoData.yoy_individual_ent > 0 ? ' up' : '')">
                          {{ infoData.yoy_individual_ent > 0 ? ' 同比增长' : '同比下降' }}
                          <b
                          >{{ infoData.yoy_individual_ent ? (infoData.yoy_individual_ent * 100).toFixed(2) + ' %' : '-' }}
                          </b>
                        </div>
                        <div v-else :class="'bottom-box' + (infoData.individual_ent_yoy > 0 ? ' up' : '')">
                          {{ infoData.individual_ent_yoy > 0 ? ' 同比增长' : '同比下降' }}
                          <b>{{ infoData.individual_ent_yoy ? infoData.individual_ent_yoy.toFixed(2) + ' %' : '-' }} </b>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-item flex-between">
              <div class="item-wrapper">
                <div class="sub-title">
                  <span>市场主体地市分布情况</span>
                  <div>
                    <span id="btn-link" @click="handleLink(111)">关联地图展示</span>
                  </div>
                </div>
                <div class="wrapper flex-between l1-2">
                  <div class="sum-list">
                    <template v-for="(item, index) in distributionList">
                      <div class="list-item" v-if="index < 5">
                        <div :class="'item-top flex-between item' + (index + 1)">
                          <div class="top-l">
                        <span>TOP {{ index + 1 }}</span
                        >{{ item.new_city }}
                          </div>
                          <div class="top-r">
                        <span>{{ item.num }}</span
                        >户
                          </div>
                        </div>
                        <div class="item-line">
                          <div class="line">
                            <div :style="`width:${(item.num / distributionList[0].num).toFixed(4) * 100}%;`">
                              <i></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-item flex-between">
              <div class="item-wrapper">
                <div class="sub-title">
                  <span>市场主体迁移分析</span>
                  <div>
                    <!-- <span id="btn-link">关联地图展示</span> -->
                  </div>
                </div>
                <PrivateMigrate ref="PrivateMigrate" :yearP="ztYyear" @openTransferModal="openTransferModal" />
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item autoplay="false">
            <div class="card-item flex-between">
              <div class="item-wrapper">
                <div class="sub-title">
                  <span>主体{{ tabIndex ? '年' : '月' }}度变化趋势</span>
                  <div>
                    <!-- <span id="btn-link">关联地图展示</span> -->
                  </div>
                </div>
                <div class="chart-con l1-1">
                  <v-chart ref="line-chart" id="line-chart" class="line-chart" :options="chartOption" />
                </div>
              </div>
            </div>
            <div class="card-item flex-between">
              <div class="item-wrapper">
                <div class="sub-title">
                  <span>市场主体类型统计</span>
                  <div>
                    <ElementSelect
                        :val="index3D"
                        :options="option3D"
                        @val="
                    (e) => {
                      index3D = e;
                    }
                  "
                    />
                    <!-- <span id="btn-link">关联地图展示</span> -->
                  </div>
                </div>
                <div class="chart-con l2-2">
                  <div class="pie-bg" v-if="index3D === 1"></div>
                  <div class="chart-pie">
                    <v-chart
                        ref="pie-chart"
                        id="pie-chart"
                        class="pie-chart"
                        v-show="index3D !== 1"
                        :options="chartOption2"
                    />
                    <v-chart
                        ref="pie3D-chart"
                        id="pie3D-chart"
                        class="pie3D-chart"
                        v-show="index3D === 1"
                        :options="chartOption2"
                    />
                    <!-- {{ chartData }} -->
                    <div :class="['chart-legend', { chart3d: index3D === 1 }]">
                      <div class="legend-list">
                        <div class="legend-item" v-for="(item, i) in chartData" :key="i">
                          <div class="name">
                        <span
                            class="color"
                            :style="{ 'background-color': index3D === 1 ? colors3D[i] : colors[i % 10] }"
                        ></span>
                            <el-tooltip effect="dark" placement="top" v-if="item.name && item.name.length > 6">
                          <span>
                            {{ item.name ? item.name : '-' }}
                          </span>
                              <div slot="content">
                                {{ item.name ? item.name : '-' }}
                              </div>
                            </el-tooltip>
                            <span v-else>
                          {{ item.name ? item.name : '-' }}
                        </span>
                          </div>
                          <span class="num">
                        {{ item.value }}
                      </span>
                          <span class="unit">户</span>
                        </div>
                      </div>
                      <div class="pager-box" v-if="index3D !== 1">
                        <i :class="['el-icon-caret-top', { dis: pager3D.current <= 1 }]" @click="changePage(false)"></i>
                        <div>
                          {{ pager3D.current }}
                          <span> / {{ pager3D.total }} </span>
                        </div>
                        <i
                            :class="['el-icon-caret-bottom', { dis: pager3D.current >= pager3D.total }]"
                            @click="changePage(true)"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-item flex-between">
              <div class="item-wrapper">
                <div class="sub-title error">
                  <span>市场主体经营异常信息</span>
                  <div>
                    <!-- <span id="btn-link">关联地图展示</span> -->
                  </div>
                </div>
                <div class="wrapper l3-2">
                  <div class="top-box">
                    <i></i>市场主体经营异常信息
                    <b></b>
                  </div>
                  <div class="list-box">
                    <div class="list-item">
                      <div>经营异常</div>
                      <b>{{ businessAnomalyStatistics.businessExceptionCount }}</b>
                    </div>
                    <div class="list-item">
                      <div>变更登记</div>
                      <b>{{ businessAnomalyStatistics.changeRegistrationCount }}</b>
                    </div>
                    <div class="list-item">
                      <div>涉企行政处罚</div>
                      <b>{{ businessAnomalyStatistics.administrativePunishmentCount }}</b>
                    </div>
                    <div class="list-item">
                      <div>互联网监管严重违法</div>
                      <b>{{ businessAnomalyStatistics.internetSupervisionSeriouslyIllegalCount }}</b>
                    </div>
                    <div class="list-item">
                      <div>欠税</div>
                      <b>{{ businessAnomalyStatistics.taxArrearsCount }}</b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
<!--        <div class="card-item flex-between">-->
<!--          <div class="item-wrapper">-->
<!--            <div class="sub-title">-->
<!--              <span>基本概况</span>-->
<!--            </div>-->
<!--            <div class="wrapper flex-between l1-1" @click="openEntModal">-->
<!--              <div class="sum-box">-->
<!--                <div class="sum-i i1"></div>-->
<!--                <div class="sum-i i2"></div>-->
<!--                <div class="sum-i i3"></div>-->
<!--                <div class="sum-i i4"></div>-->
<!--                <div class="sum-img"></div>-->
<!--                <div class="sum-h1">民营经济市场主体总量</div>-->
<!--                <div class="sum-h2">-->
<!--                  <b>{{ infoData.market_main_body_num }}</b-->
<!--                  >{{ tabIndex ? '户' : '万户' }}-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="sum-list">-->
<!--                <div class="list-item">-->
<!--                  <div class="item-left item1">-->
<!--                    <i class="i-img"></i>-->
<!--                    <i v-if="tabIndex" :class="'i-trend' + (infoData.yoy_main_body > 0 ? ' up' : '')"></i>-->
<!--                    <i v-else :class="'i-trend' + (infoData.ent_yoy > 0 ? ' up' : '')"></i>-->
<!--                  </div>-->
<!--                  <div class="item-right">-->
<!--                    <h3>民营企业数量</h3>-->
<!--                    <div class="middle-box">-->
<!--                      <b>{{ tabIndex ? infoData.main_body_num : infoData.ent_num }}</b-->
<!--                      >{{ tabIndex ? '户' : '万户' }}-->
<!--                    </div>-->
<!--                    <div v-if="tabIndex" :class="'bottom-box' + (infoData.yoy_main_body > 0 ? ' up' : '')">-->
<!--                      {{ infoData.yoy_main_body > 0 ? ' 同比增长' : '同比下降' }}-->
<!--                      <b>{{ infoData.yoy_main_body ? infoData.yoy_main_body.toFixed(2) + ' %' : '-' }} </b>-->
<!--                    </div>-->
<!--                    <div v-else :class="'bottom-box' + (infoData.ent_yoy > 0 ? ' up' : '')">-->
<!--                      {{ infoData.ent_yoy > 0 ? ' 同比增长' : '同比下降' }}-->
<!--                      <b>{{ infoData.ent_yoy ? infoData.ent_yoy.toFixed(2) + ' %' : '-' }} </b>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="list-item">-->
<!--                  <div class="item-left item2">-->
<!--                    <i class="i-img"></i>-->
<!--                    <i v-if="tabIndex" :class="'i-trend' + (infoData.yoy_individual_ent > 0 ? ' up' : '')"></i>-->
<!--                    <i v-else :class="'i-trend' + (infoData.individual_ent_yoy > 0 ? ' up' : '')"></i>-->
<!--                  </div>-->
<!--                  <div class="item-right">-->
<!--                    <h3>个体工商户数量</h3>-->
<!--                    <div class="middle-box">-->
<!--                      <b>{{ infoData.individual_ent_num }}</b-->
<!--                      >{{ tabIndex ? '户' : '万户' }}-->
<!--                    </div>-->
<!--                    <div v-if="tabIndex" :class="'bottom-box' + (infoData.yoy_individual_ent > 0 ? ' up' : '')">-->
<!--                      {{ infoData.yoy_individual_ent > 0 ? ' 同比增长' : '同比下降' }}-->
<!--                      <b-->
<!--                        >{{ infoData.yoy_individual_ent ? (infoData.yoy_individual_ent * 100).toFixed(2) + ' %' : '-' }}-->
<!--                      </b>-->
<!--                    </div>-->
<!--                    <div v-else :class="'bottom-box' + (infoData.individual_ent_yoy > 0 ? ' up' : '')">-->
<!--                      {{ infoData.individual_ent_yoy > 0 ? ' 同比增长' : '同比下降' }}-->
<!--                      <b>{{ infoData.individual_ent_yoy ? infoData.individual_ent_yoy.toFixed(2) + ' %' : '-' }} </b>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="item-wrapper">-->
<!--            <div class="sub-title">-->
<!--              <span>主体{{ tabIndex ? '年' : '月' }}度变化趋势</span>-->
<!--              <div>-->
<!--                &lt;!&ndash; <span id="btn-link">关联地图展示</span> &ndash;&gt;-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="chart-con">-->
<!--              <v-chart ref="line-chart" id="line-chart" class="line-chart" :options="chartOption" />-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="card-item flex-between">-->
<!--          <div class="item-wrapper">-->
<!--            <div class="sub-title">-->
<!--              <span>市场主体地市分布情况</span>-->
<!--              <div>-->
<!--                <span id="btn-link" @click="handleLink(111)">关联地图展示</span>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="wrapper flex-between l1-2">-->
<!--              <div class="sum-list">-->
<!--                <template v-for="(item, index) in distributionList">-->
<!--                  <div class="list-item" v-if="index < 5">-->
<!--                    <div :class="'item-top flex-between item' + (index + 1)">-->
<!--                      <div class="top-l">-->
<!--                        <span>TOP {{ index + 1 }}</span-->
<!--                        >{{ item.new_city }}-->
<!--                      </div>-->
<!--                      <div class="top-r">-->
<!--                        <span>{{ item.num }}</span-->
<!--                        >户-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="item-line">-->
<!--                      <div class="line">-->
<!--                        <div :style="`width:${(item.num / distributionList[0].num).toFixed(4) * 100}%;`">-->
<!--                          <i></i>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </template>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="item-wrapper">-->
<!--            <div class="sub-title">-->
<!--              <span>市场主体类型统计</span>-->
<!--              <div>-->
<!--                <ElementSelect-->
<!--                  :val="index3D"-->
<!--                  :options="option3D"-->
<!--                  @val="-->
<!--                    (e) => {-->
<!--                      index3D = e;-->
<!--                    }-->
<!--                  "-->
<!--                />-->
<!--                &lt;!&ndash; <span id="btn-link">关联地图展示</span> &ndash;&gt;-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="chart-con l2-2">-->
<!--              <div class="pie-bg" v-if="index3D === 1"></div>-->
<!--              <div class="chart-pie">-->
<!--                <v-chart-->
<!--                  ref="pie-chart"-->
<!--                  id="pie-chart"-->
<!--                  class="pie-chart"-->
<!--                  v-show="index3D !== 1"-->
<!--                  :options="chartOption2"-->
<!--                />-->
<!--                <v-chart-->
<!--                  ref="pie3D-chart"-->
<!--                  id="pie3D-chart"-->
<!--                  class="pie3D-chart"-->
<!--                  v-show="index3D === 1"-->
<!--                  :options="chartOption2"-->
<!--                />-->
<!--                &lt;!&ndash; {{ chartData }} &ndash;&gt;-->
<!--                <div :class="['chart-legend', { chart3d: index3D === 1 }]">-->
<!--                  <div class="legend-list">-->
<!--                    <div class="legend-item" v-for="(item, i) in chartData" :key="i">-->
<!--                      <div class="name">-->
<!--                        <span-->
<!--                          class="color"-->
<!--                          :style="{ 'background-color': index3D === 1 ? colors3D[i] : colors[i % 10] }"-->
<!--                        ></span>-->
<!--                        <el-tooltip effect="dark" placement="top" v-if="item.name && item.name.length > 6">-->
<!--                          <span>-->
<!--                            {{ item.name ? item.name : '-' }}-->
<!--                          </span>-->
<!--                          <div slot="content">-->
<!--                            {{ item.name ? item.name : '-' }}-->
<!--                          </div>-->
<!--                        </el-tooltip>-->
<!--                        <span v-else>-->
<!--                          {{ item.name ? item.name : '-' }}-->
<!--                        </span>-->
<!--                      </div>-->
<!--                      <span class="num">-->
<!--                        {{ item.value }}-->
<!--                      </span>-->
<!--                      <span class="unit">户</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="pager-box" v-if="index3D !== 1">-->
<!--                    <i :class="['el-icon-caret-top', { dis: pager3D.current <= 1 }]" @click="changePage(false)"></i>-->
<!--                    <div>-->
<!--                      {{ pager3D.current }}-->
<!--                      <span> / {{ pager3D.total }} </span>-->
<!--                    </div>-->
<!--                    <i-->
<!--                      :class="['el-icon-caret-bottom', { dis: pager3D.current >= pager3D.total }]"-->
<!--                      @click="changePage(true)"-->
<!--                    ></i>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="card-item flex-between">-->
<!--          <div class="item-wrapper">-->
<!--            <div class="sub-title">-->
<!--              <span>市场主体迁移分析</span>-->
<!--              <div>-->
<!--                &lt;!&ndash; <span id="btn-link">关联地图展示</span> &ndash;&gt;-->
<!--              </div>-->
<!--            </div>-->
<!--            <PrivateMigrate ref="PrivateMigrate" :yearP="ztYyear" @openTransferModal="openTransferModal" />-->
<!--          </div>-->
<!--          <div class="item-wrapper">-->
<!--            <div class="sub-title error">-->
<!--              <span>市场主体经营异常信息</span>-->
<!--              <div>-->
<!--                &lt;!&ndash; <span id="btn-link">关联地图展示</span> &ndash;&gt;-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="wrapper l3-2">-->
<!--              <div class="top-box">-->
<!--                <i></i>市场主体经营异常信息-->
<!--                <b></b>-->
<!--              </div>-->
<!--              <div class="list-box">-->
<!--                <div class="list-item">-->
<!--                  <div>经营异常</div>-->
<!--                  <b>155</b>-->
<!--                </div>-->
<!--                <div class="list-item">-->
<!--                  <div>变更登记</div>-->
<!--                  <b>944</b>-->
<!--                </div>-->
<!--                <div class="list-item">-->
<!--                  <div>涉企行政处罚</div>-->
<!--                  <b>469</b>-->
<!--                </div>-->
<!--                <div class="list-item">-->
<!--                  <div>互联网监管严重违法</div>-->
<!--                  <b>231</b>-->
<!--                </div>-->
<!--                <div class="list-item">-->
<!--                  <div>欠税</div>-->
<!--                  <b>15</b>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
    <EleDialog
      :title="`${ztYyear}年${searchTransfer.dataType === 1 ? '迁入' : '迁出'}企业名单`"
      :visible.sync="showDialogTransfer"
      class="info-modal"
    >
      <div class="filter-box">
        <ElementSelect
          :val="searchTransfer.city"
          :options="optionCity"
          :placeholder="'请选择地市'"
          @change="
            (e) => {
              searchTransfer.city = e + '市';
              openTransferModal();
            }
          "
          size="middle"
        />
        <EleInput v-model="searchTransfer.entName" placeholder="请输入企业名称" clearable />
      </div>
      <ComTable
        :tableCol="tableColT"
        :tableData="tableDataT"
        :pager="pagerTransfer"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      />
    </EleDialog>
    <EleDialog title="企业概况" :visible.sync="showCompany" class="company-profile">
      <CompModal v-if="showCompany" :curData="curData" :year="ztYyear"></CompModal>
    </EleDialog>
    <EleDialog :title="ztYyear + '年广东省民营企业市场主体清单'" :visible.sync="showDialog" class="info-modal">
      <div class="filter-box">
        <ElementSelect
          :val="search.city"
          :options="ModalOption.City"
          :placeholder="'请选择地市'"
          clearable
          @change="
            (e) => {
              search.city = e;
              openEntModal();
            }
          "
          size="middle"
        />
        <ElementSelect
          :val="search.entType"
          :options="ModalOption.EntType"
          :placeholder="'请选择企业类型'"
          clearable
          @change="
            (e) => {
              search.entType = e;
              openEntModal();
            }
          "
          size="middle"
        />
        <ElementSelect
          :val="search.hyType"
          :options="ModalOption.HyVal"
          :placeholder="'请选择行业类型'"
          clearable
          @change="
            (e) => {
              search.hyType = e;
              openEntModal();
            }
          "
          size="middle"
        />
        <ElementSelect
          :val="search.cyType"
          :options="ModalOption.CyVal"
          :placeholder="'请选择产业类型'"
          clearable
          @change="
            (e) => {
              search.cyType = e;
              openEntModal();
            }
          "
          size="middle"
        />
        <EleInput v-model="search.entName" placeholder="请输入企业名称" clearable />
      </div>
      <ComTable
        v-loading="loading"
        element-loading-background="rgba(0, 0, 0, 0.5)"
        :tableCol="tableCol"
        :tableData="tableData"
        :pager="pager"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      />
    </EleDialog>
  </div>
</template>

<script>
import $ from 'jquery';
import drawLine from '../chartJs/MainTrend';
import FinancialService from './FinancialService.vue';
import drawPie from '../chartJs/pie';
import drawPie3D from '../chartJs/pie3D';
import PrivateMigrate from './PrivateMigrate.vue';
import echarts from 'echarts';
import ComTable from '../../../components/ComTable';
import CompModal from './CompModal.vue';
import TabList from '../../../components/tabList';
import MarketSubjectType from './MarketSubjectType';
import MarketMainIndustry from './MarketMainIndustry.vue';
import ElementSelect from '../../../components/element-select';
import cityJson from '../cityJson';
import { getTime } from '@/utils/tool';

const colors3D = ['#00c9ff', '#0078ff', '#fcf5c2', '#58ecac'];
const colors = [
  '#00c5fa',
  '#0078ff',
  '#fcf5c2',
  '#58ecac',
  '#ff8c60',
  '#a280ff',
  '#ee6566',
  '#fac959',
  '#91cd74',
  '#3aa272',
  // '#aae6ff',
];
export default {
  name: 'ChartBar',
  components: {
    ElementSelect,
    ComTable,
    TabList,
    MarketSubjectType,
    MarketMainIndustry,
    CompModal,
    FinancialService,
    PrivateMigrate,
  },
  props: {
    yearP: {
      type: Number,
      default: 2023,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      businessAnomalyStatistics: {
        businessExceptionCount: 0,
        changeRegistrationCount: 0,
        administrativePunishmentCount: 0,
        internetSupervisionSeriouslyIllegalCount: 0,
        taxArrearsCount: 0
      },
      chart: null,
      loading: false,
      loadingLine: true,
      chartOption: null,
      chartOption2: null,
      chartOption3: null,
      chartOptionLine: null,
      colors3D,
      colors,
      option3D: [
        {
          value: 1,
          label: '产业',
        },
        {
          value: 2,
          label: '行业',
        },
        {
          value: 3,
          label: '支柱产业',
        },
        {
          value: 4,
          label: '市场主体类型',
        },
      ],
      index3D: 1,
      chartData: null,
      chartData2: null,
      chartData3: null,
      infoData: {},
      distributionList: [],
      disTotal: 0,
      year: this.yearP,
      ztYyear: 0,
      tabList: [
        {
          key: 1,
          label: '累计总数',
        },
        {
          key: 2,
          label: '本年新增',
        },
        {
          key: 3,
          label: '本年注销',
        },
      ],
      statisData: null,
      tabIndex: 0,
      options: [],
      ztYearList: [],
      ztYearOption: [],
      ModalOption: {},
      showDialog: false,
      showDialogTransfer: false,
      showCompany: false,
      search: {
        city: undefined,
        cyType: undefined,
        entName: undefined,
        entType: undefined,
        hyType: undefined,
      },
      searchTransfer: {
        dataType: 1, // 迁入1，迁出2
      },
      optionCity: [
        // {
        //   value: '全省',
        //   label: '全省',
        // },
        ...cityJson.filter((x) => x.value !== '省直'),
      ],
      tableData: [],
      pager: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      tableDataT: [],
      pagerTransfer: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      curData: null,
      pager3D: {
        current: 1,
        total: 2,
      },
      legendBox: null,
    };
  },
  created() {
    this.getBusinessAnomalyStatistics();
    this.year = new Date().getFullYear();
    this.options = [
      {
        value: this.year,
        label: this.year,
      },
    ];
    while (this.options.slice(-1)[0].value > 2021) {
      let tmp = this.options.slice(-1)[0];
      this.options.push({
        value: tmp.value - 1,
        lable: tmp.value - 1,
      });
    }
    console.log(this.options);
  },
  computed: {
    businessExceptionCount(){
      return this.businessAnomalyStatistics.businessExceptionCount
    },
    tableCol() {
      return [
        {
          label: '序号',
          type: 'index',
          maxWidth: 70,
        },
        {
          label: '地市',
          param: 'creater_city',
        },
        {
          label: '企业名称',
          param: 'entname',
          fn: (x) => {
            this.showDialog = false;
            this.curData = { ...x, companyName: x.entname };
            this.showCompany = true;
          },
        },
        {
          label: '企业类型',
          param: 'enttype',
        },
        {
          label: '行业类型',
          param: 'cyval',
        },
        {
          label: '成立时间',
          param: 'clsj',
        },
        {
          label: '登记机关',
          param: 'djjg',
        },
      ];
    },
    tableColT() {
      let arr =
        this.searchTransfer.dataType === 1
          ? [
              {
                label: '迁入日期',
                param: 'qrrq',
              },
              {
                label: '企业名称',
                param: 'ent_name',
                fn: (x) => {
                  this.showDialog = false;
                  this.curData = { ...x, companyName: x.ent_name };
                  this.showCompany = true;
                },
              },
              {
                label: '迁入原因',
                param: 'qeyy',
              },
            ]
          : [
              {
                label: '迁出日期',
                param: 'qcrq',
              },
              {
                label: '企业名称',
                param: 'ent_name',
                fn: (x) => {
                  this.showDialogTransfer = false;
                  this.curData = { ...x, companyName: x.ent_name };
                  this.showCompany = true;
                },
              },
              {
                label: '迁出原因',
                param: 'qcyy',
              },
            ];
      return [
        ...arr,
        {
          label: '迁出地',
          param: 'qcdq',
        },
        {
          label: '迁入地',
          param: 'qrdq',
        },
        {
          label: '迁出登地登记机关',
          param: 'qcdjjg',
        },
        {
          label: '迁入地登记机关',
          param: 'qrdjjg',
        },
      ];
    },
  },
  watch: {
    ztYyear(){
      this.getData()
    },

    year() {
      this.$nextTick(() => {
        // this.getCity();
      });
    },
    index3D(n) {
      if (n) {
        this.chart.off('click');
        this.chart.off('mouseover');
        this.chart.off('globalout');
      }
      this.chart = null;
      this.chartOption2 = null;
      this.$nextTick(() => {
        this.get3DData();
      });
    },
    chartData(n) {
      this.pager3D.total = n?.length ? Math.ceil((n?.length * 20) / this.legendBox.clientHeight) : 0;
    },
    'pager3D.current'(n) {
      if (n) {
        let box = this.legendBox;
        let y = box.clientHeight * (n - 1);
        console.log(box.clientHeight, n, y);
        box.style.transform = `translateY(-${y > 0 ? y + 15 : y}px)`;
      }
    },
    'search.entName'(n) {
      if (!n) {
        this.search.entName = null;
      }
      this.pager.currentPage = 1;
      this.$nextTick(() => this.openEntModal());
    },
    showCompany(n) {
      if (!n) this.curData = null;
    },
    'searchTransfer.entName'(n) {
      if (!n) {
        this.searchTransfer.entName = null;
      }
      this.pagerTransfer.currentPage = 1;
      this.$nextTick(() => this.openTransferModal());
    },
  },
  methods: {
    handleLink(index) {
      this.$emit('handleLink', {
        index,
        dataType: this.tabIndex + 1,
        year: this.year,
      });
    },
    getBusinessAnomalyStatistics(){
      this.$api.market
      .getBusinessAnomalyStatistics()
      .then((res) => {
        let {data} = res.data
        this.businessAnomalyStatistics = data;
        console.log(this.businessAnomalyStatistics, 1000);
      });
    },
    getData() {
      this.$api.market.getZtYearOption({dataType: this.tabList[this.tabIndex].key}).then((res) => {
        this.ztYearOption = res.data.data.data;
        if (this.ztYyear === 0) {
          this.ztYyear = this.ztYearOption[0];
          this.ztYearList = []
          for (let key in this.ztYearOption) {
            this.ztYearList.push(
                    {
                      value: this.ztYearOption[key],
                      lable: this.ztYearOption[key],
                    }
            );
          }
        }
      });
      if (this.ztYyear === 0) {
        return;
      }

      // let chart = echarts.init(document.getElementById('bar-chart'));
      if (this.tabIndex) {
        this.$api.market
          .getScztqkNewlyDetail({
            year: this.ztYyear,
            dataType: this.tabIndex + 1,
          })
          .then((res) => {
            let { data } = res.data;
            this.infoData = data.data[0];
            console.log(this.infoData, 1000);
          });
        this.chartOption = null;
        this.$api.market
          .getScztqkMoonTrend({
            year: this.ztYyear,
            dataType: this.tabIndex + 1,
          })
          .then((res) => {
            let data = res.data.data.data.map((x) => {
              let tmp = +x.mon_val.split('-')[1];
              return {
                mon_val: tmp + '月',
                num: x.num,
              };
            });
            // this.lineRateData = data;
            this.chartOption = drawLine(data, '户', this.tabIndex);
          });
      } else {
        this.$api.market
          .getMarketSubjectStatistics({
            year: this.ztYyear,
          })
          .then((res) => {
            let { data } = res.data.data;
            this.infoData = data;
            console.log(this.infoData, 1000);
          });
        this.$api.market
          .getScztqkTrend({
            year: this.ztYyear,
          })
          .then((res) => {
            let data = res.data.data.data.map((x) => ({
              ...x,
              num: (x.num / 10000).toFixed(4),
            }));

            // this.lineRateData = data;
            this.chartOption = drawLine(data, '万户', this.tabIndex);
          });
      }

      this.$api.market
        .getScztqkDistribution({
          dataType: this.tabIndex + 1,
          year: this.ztYyear,
        })
        .then((res) => {
          let { data } = res.data.data;
          this.distributionList = data;
          // data.map((x) => {
          //   this.disTotal += x.num;
          // });
        });
      setTimeout(() => {
        this.get3DData();
        let box = $('.legend-list');
        this.legendBox = box[0];
      }, 900);
    },
    setInterData() {
      this.$nextTick(() => {
        // let refName = 'pie3D-chart';
        let refName = this.index3D === 1 ? 'pie3D-chart' : 'pie-chart';
        this.$refs[refName].clear();

        if (this.index3D === 1) {
          this.chartOption2 = drawPie3D(this.chartData, 0, this.chart);
        } else {
          this.chartOption2 = drawPie(this.chartData);
        }
      });
    },
    getLine() {
      //折线图
      let api,
        q = {};
      if (this.tabIndex === 0) api = 'getEnterpriseFiveYear';
      else {
        api = 'getEnterpriseMonth';
        q.status = (this.tabIndex === 2 ? [3, 4] : [1, 2]).toString();
      }
      this.$api.market[api](q).then((res) => {
        let { data } = res.data;
        let arr = [],
          l = [];
        if (data) {
          arr = data.map((x) => {
            let c = 0;
            if (Number(x.count) > 0) c = (Number(x.count) / 10000).toFixed(4);
            if (this.tabIndex) {
              let tmp = Number(x.month.split('-')[1]) - 1;
              l[tmp] = c;
            } else {
              l.push(c);
              return x.year;
            }
          });
        }
        for (let i = 0; i < 12; i++) {
          if (!l[i]) l[i] = 0;
        }
        console.log(l);
        let list = {
          data: data ? l : [],
          names: ['总数'],
          yAxis: {
            name: '单位： 万户',
          },
          xAxis: {
            show: this.tabIndex === 0,
            data: arr,
          },
        };
        // this.chartData = list;
        this.chartOptionLine = drawLine(list);
        this.loadingLine = false;
      });
    },
    changeTab(item, i) {
      this.ztYyear = 0;
      console.log(item, i);
      this.tabIndex = i;
      this.getData();
    },
    openModal() {
      let dy = {};
      if (this.search.cityName && this.search.cityName !== '全省') dy.city = this.search.cityName + '市';
      if (this.search.enterpriseName) dy.f29034_34aa047003 = this.search.enterpriseName;
      this.loading = true;
      this.$api.common
        .getFormData(
          {
            dynamicConditions: dy,
            pageCurrent: this.pager.currentPage,
            pageSize: 10,
            syncFormId: 1,
          },
          [],
          {
            showMsg: false,
          },
        )
        .then((res) => {
          this.showDialog = true;
          if (res.data.data) {
            this.pager.total = res.data.data.total;
            this.tableData = res.data.data.records.map((x) => ({
              ...x,
              f29034_34aa047009: x.f29034_34aa047009 ? getTime(new Date(x.f29034_34aa047009), 'yyyy-MM-dd') : '-',
            }));
          } else {
            this.pager.total = 0;
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.pager.total = 0;
          this.tableData = [];
          this.loading = false;
        });
    },
    openEntModal() {
      this.showDialog = true;
      this.loading = true;
      this.$api.market
        .getEntModalList({
          ...this.search,
          dataType: this.tabIndex + 1,
          year: this.ztYyear,
          pageNum: this.pager.currentPage,
          pageSize: this.pager.pageSize,
        })
        .then((res) => {
          this.tableData = res.data.data.records.map((x) => ({
            ...x,
            clsj: getTime(new Date(x.clsj)),
          }));
          this.pager.total = res.data.data.total;
          this.loading = false;
        });
    },
    handleSizeChange(e) {
      if (this.showDialogTransfer) {
        this.pagerTransfer.pageSize = e;
        this.openTransferModal();
      } else {
        this.pager.pageSize = e;
        this.openEntModal();
      }
    },
    handleCurrentChange(e) {
      if (this.showDialogTransfer) {
        this.pagerTransfer.currentPage = e;
        this.openTransferModal();
      } else {
        this.pager.currentPage = e;
        this.openEntModal();
      }
    },
    openTransferModal(addr, e) {
      if (!this.showDialogTransfer) {
        this.searchTransfer = {
          dataType: 1,
        };
      }
      this.showDialogTransfer = true;
      if (addr) this.searchTransfer.city = addr;
      if (e) this.searchTransfer.dataType = e;
      this.$api.market
        .getEntOutInList({
          year: this.ztYyear,
          ...this.searchTransfer,
          city: this.searchTransfer.city,
          pageNum: this.pagerTransfer.currentPage,
          pageSize: this.pagerTransfer.pageSize,
        })
        .then((res) => {
          this.tableDataT = res.data.data.records.map((x) => ({
            ...x,
            qrrq: getTime(new Date(x.qrrq)),
            qcrq: getTime(new Date(x.qcrq)),
          }));
          this.pagerTransfer.total = res.data.data.total;
        });
    },
    changePage(next) {
      let { current, total } = this.pager3D;
      if (next) {
        this.pager3D.current = current < total ? current + 1 : current;
      } else {
        this.pager3D.current = current > 1 ? current - 1 : current;
      }
    },
    get3DData() {
      this.chart =
        this.index3D === 1
          ? echarts.init(document.getElementById('pie3D-chart'))
          : echarts.init(document.getElementById('pie-chart'));
      this.$api.market
        .getScztqkSubject({
          dataType: this.index3D,
          optionType: this.tabIndex + 1,
          // this.tabList[this.tabIndex].label,
          year: this.ztYyear,
        })
        .then((res) => {
          let { data } = res.data.data;
          if (data?.length) {
            let list = data.map((item) => {
              // let name =
              //   this.index3D === 1
              //     ? item.industry_name
              //     : this.index3D === 2
              //     ? item.industry_name
              //     : this.index3D === 4
              //     ? item.industry_name
              //     : item.industry_name;
              return {
                name: item.industry_name,
                value: item.num,
              };
            });
            this.chartData = list;
            this.$nextTick(() => {
              this.setInterData();
            });
          } else {
            this.selectList = this.selectList.filter((x) => x.value !== this.ztYyear);
            this.ztYyear = this.selectList[0].value;
          }
        });
    },
  },
  mounted() {
    this.getData();
    this.getBusinessAnomalyStatistics();
    this.$api.market.getEntModalOption().then((res) => {
      let { City, CyVal, EntType, HyVal } = res.data.data;
      this.ModalOption = {
        City: City.map((x) => ({
          label: x.creater_city,
          value: x.creater_city,
        })),
        CyVal: CyVal.map((x) => ({
          label: x.cy_val,
          value: x.cy_val,
        })),
        EntType: EntType.map((x) => ({
          label: x.ent_type,
          value: x.ent_type,
        })),
        HyVal: HyVal.map((x) => ({
          label: x.hy_val,
          value: x.hy_val,
        })),
      };
    });
  },
};
</script>

<style lang="less" scoped>
.chart-bar {
  .chart-box();
  width: 100%;
  height: 100% !important;
  margin: 0;
  display: flex;
  justify-content: space-between;
  .chart-card {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    /deep/ .tab-list {
      margin: 5px 0 0;
      .list {
        position: unset;
      }
    }
    .card-item {
      align-items: flex-start;
      padding: 0 21px;

      + .card-item {
        margin-top: 10px;
        // flex-direction: column;
      }
      .item-wrapper {
        width: calc((100% - 31px));
        height: 100%;
        display: flex;
        flex-direction: column;
        + .item-wrapper {
          margin-left: 29px;
        }
      }
    }
    .l2-2 .card-content,
    .l2-3 .card-content {
      flex: 1;
    }
    .l2-2 {
      height: 440px;
      overflow: inherit;
      .pie-bg {
        width: 431px;
        height: 198px;
        background: url('~img/home/pie-bg.png') no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: -19px;
        bottom: 30px;
        /*z-index: 2;*/
      }
      .chart-pie {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 10px;
      }

      #pie-chart,
      #pie3D-chart {
        width: 465px;
        height: 300px;
        margin-top: 110px;
      }
      .chart-legend {
        // flex: 1;
        width: calc(100% - 245px);
        /*width: 50%;*/
        color: #fff;
        height: 300px;
        padding-right: 10px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        max-height: 160px;
        overflow: hidden;
        //.show-scroll-bg-trans();

        &.chart3d {
          justify-content: center;
          margin-top: 30px;
          // max-height: 200px;

          .legend-item {
            line-height: 30px;
            margin-bottom: 20px;
          }
        }

        .legend-list {
          display: flex;
          flex-direction: column;
          // align-items: center;
          // justify-content: center;
          height: calc(100% - 20px);
          transition: all 0.3s;
        }

        .pager-box {
          position: absolute;
          right: 0;
          bottom: 10px;
          .flex-center();
          padding-right: 10px;
          font-size: 12px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #87e6ff;
          line-height: 38px;

          div {
            letter-spacing: -2px;
            margin: 0 10px;

            span {
              color: rgba(135, 230, 255, 0.3);
            }
          }

          i {
            margin-top: 2px;
            cursor: pointer;

            &.dis {
              color: rgba(135, 230, 255, 0.3);
              cursor: not-allowed;
            }
          }
        }

        .legend-item {
          .flex-center();
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #dcdcdc;
          /*line-height: 20px;*/
          margin-bottom: 10px;

          &:first-child {
            // margin-top: 10px;
          }

          .name {
            width: 250px;
            .flex-center();

            span:last-child {
              width: calc(100% - 21px);
              .ellipsis();
            }
          }
        }

        .color {
          width: 15px;
          height: 11px;
          margin-right: 6px;
        }

        .num {
          width: 80px;
          font-size: 23px;
          font-family: Geometr706 BlkCn BT;
          font-weight: 900;
          color: #fff;
          line-height: 30px;
          margin: 0 5px 0 20px;
          text-align: right;
        }

        .unit {
          font-size: 20px;
        }
      }
    }
    .card-title {
      width: 100%;
      height: 36px;
      background: url('~img/market/market-card-title.png') no-repeat;
      background-size: 100% 100%;
      padding-left: 17px;
      box-sizing: border-box;
      div {
        font-family: 'AlibabaPB';
        font-weight: bold;
        font-size: 25px;
        color: #ffffff;
        line-height: 36px;
        // text-shadow: 0px 2px 8px rgba(5, 28, 55, 0.42);
        font-style: italic;
        background: linear-gradient(
          180deg,
          rgba(189, 232, 247, 1) 0%,
          rgba(191, 229, 252, 1) 20%,
          rgba(249, 253, 254, 1) 58.7646484375%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .card-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      padding-top: 2px;
      margin: -1px 1px 1px;
      background: linear-gradient(90deg, rgba(6, 17, 29, 0) 0%, rgba(58, 90, 127, 0.208) 44%, rgba(6, 17, 29, 0) 100%);
      border-radius: 4px;
      border: 1px solid;
      border-image: linear-gradient(0deg, rgba(154, 234, 255, 0.15), rgba(154, 234, 255, 0.15)) 1 1;
      border-top: none;
    }
  }
  .wrapper {
    padding: 0 10px;
    * {
      box-sizing: border-box;
    }
  }
  .l1-1 {
    height: 250px;
    padding: 0;
    cursor: pointer;
    .sum-box {
      position: relative;
      width: 197px;
      height: 218px;
      padding: 28px 0;
      margin-right: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: rgba(50, 98, 190, 0.11);
      border-top: 2px dashed rgba(104, 230, 255, 0.2);
      border-bottom: 2px dashed rgba(104, 230, 255, 0.2);
      .sum-i {
        position: absolute;
        width: 8px;
        height: 8px;
        border: 2px solid #68e6ff;
        &.i1 {
          left: -1px;
          top: -2px;
          border-right: none;
          border-bottom: none;
        }
        &.i2 {
          right: -1px;
          top: -2px;
          border-left: none;
          border-bottom: none;
        }
        &.i3 {
          left: -1px;
          bottom: -2px;
          border-right: none;
          border-top: none;
        }
        &.i4 {
          right: -1px;
          bottom: -2px;
          border-left: none;
          border-top: none;
        }
      }
      .sum-img {
        width: 120px;
        height: 117px;
        background: url('~img/market/market-r-sum.png') no-repeat;
        background-size: 100% 100%;
      }
      .sum-h1 {
        font-family: Alibaba PuHuiTi 2;
        font-weight: normal;
        font-size: 20px;
        color: rgba(216, 226, 255, 0.8);
        line-height: 1;
        font-style: italic;
        white-space: nowrap;
        margin: 20px;
      }
      .sum-h2 {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 18px;
        color: rgba(239, 240, 241, 0.6);
        line-height: 1;
        b {
          margin-right: 8px;
          font-family: YouSheTitle;
          font-weight: 400;
          font-size: 26px;
          color: #e4edf7;
        }
      }
    }
    .sum-list {
      flex: 1;
      height: 100%;
      .list-item {
        display: flex;
        align-items: center;
        + .list-item {
          margin-top: 59px;
        }
        .item-left {
          display: flex;
          flex-direction: column;
          align-items: center;
          .i-img {
            width: 96px;
            height: 66px;
            background: url('~img/market/market-r-sum1.png') no-repeat;
            background-size: 100% 100%;
          }
          &.item2 .i-img {
            background: url('~img/market/market-r-sum2.png') no-repeat;
            background-size: 100% 100%;
          }
          .i-trend {
            margin-top: 7px;
            width: 31px;
            height: 16px;
            background: url('~img/market/market-l-down.png') no-repeat;
            background-size: 100% 100%;
            &.up {
              background: url('~img/market/market-l-up.png') no-repeat;
              background-size: 100% 100%;
            }
          }
        }
        .item-right {
          h3 {
            margin: 0;
            font-family: Alibaba PuHuiTi 2;
            font-weight: normal;
            font-size: 20px;
            color: rgba(216, 226, 255, 0.6);
            line-height: 1;
            font-style: italic;
          }
          .middle-box {
            font-family: Alibaba PuHuiTi 2;
            font-weight: normal;
            font-size: 18px;
            color: rgba(216, 226, 255, 0.5);
            line-height: 1;
            font-style: italic;
            margin: 10px 0 16px;
            b {
              font-family: Geometr706 BlkCn BT;
              font-weight: 900;
              font-size: 26px;
              color: #d8e2ff;
              line-height: 28px;
              font-style: italic;
              background: linear-gradient(-7deg, #f5f8ff 0.1220703125%, #d8e2ff 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              padding-right: 5px;
              margin-right: 7px;
            }
          }
          .bottom-box {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 18px;
            color: #d8e2ff;
            line-height: 1;
            font-style: italic;
            color: #f5f8ff;
            b {
              font-family: Geometr706 BlkCn BT;
              font-weight: 900;
              font-size: 18px;
              color: #d8e2ff;
              line-height: 1;
              font-style: italic;
              background: linear-gradient(0deg, #19490a 0.9033203125%, #7cfa00 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              padding-right: 5px;
              margin-left: 12px;
            }
            &.up b {
              background: linear-gradient(-7deg, #ffca00 0%, #ff5a00 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
        }
      }
    }
  }
  .l1-2 {
    height: 440px;
    .sum-list {
      // padding-top: 17px;
      width: 100%;
      height: 100%;
      .list-item {
        + .list-item {
          margin-top: 15px;
        }
        .item-top {
          .top-l {
            font-family: Source Han Sans CN;
            font-weight: 500;
            font-size: 23px;
            color: #ffffff;
            span {
              font-family: Myriad Pro;
              font-weight: 400;
              font-size: 23px;
              color: #49acff;
              margin-right: 19px;
            }
          }
          .top-r {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 18px;
            color: #d8e2ff;
            font-style: italic;
            span {
              font-family: Geometr706 BlkCn BT;
              font-weight: 900;
              font-size: 23px;
              color: #ffffff;
              font-style: italic;
              background: linear-gradient(0deg, #f5f8ff 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              margin-right: 4px;
            }
          }
          &.item1 {
            .top-l span {
              color: #fb3c00;
            }
            .top-r span {
              background: linear-gradient(0deg, #f63d01 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          &.item2 {
            .top-l span {
              color: #fa9300;
            }
            .top-r span {
              background: linear-gradient(0deg, #f48f00 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          &.item3 {
            .top-l span {
              color: #7ffc00;
            }
            .top-r span {
              background: linear-gradient(0deg, #82f40e 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          &.item4 {
            .top-l span {
              color: #49acff;
            }
            .top-r span {
              background: linear-gradient(0deg, #f5f8ff 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          &.item1,
          &.item2,
          &.item3 {
            + .item-line .line div {
              height: 6px;
              top: -1px;
              i {
                top: -2px;
              }
            }
          }
        }
        .item-line {
          width: 100;
          height: 16px;
          background: rgba(16, 28, 52, 0.5);
          padding: 5px 4px;
          margin-top: 2px;
          .line {
            position: relative;
            width: 100%;
            height: 4px;
            background: #0a284a;
            border-radius: 2px;
            div {
              position: absolute;
              left: 0;
              top: 0;
              width: 80%;
              height: 4px;
              background: linear-gradient(270deg, #51b0ff 0%, rgba(0, 120, 255, 0) 100%);
              border-radius: 2px;
              i {
                position: absolute;
                right: 0;
                top: -3px;
                width: 10px;
                height: 10px;
                display: inline-block;
                background: #e3f2ff;
                box-shadow: 0 0 7px rgba(227, 242, 255, 1);
                border-radius: 50%;
              }
            }
          }
        }
      }
    }
  }
  .l2-1 {
    height: 250px;
    .list-box {
      width: 100%;
      height: 253px;
      padding: 17px 0 8px;
      .list-item {
        width: 100%;
        height: 38px;
        border-radius: 4px;
        border: 1px solid #2b97ff;
        padding: 0 39px 0 36px;
        + .list-item {
          margin-top: 5px;
        }
        .item-l {
          font-family: Source Han Sans CN;
          font-weight: bold;
          font-size: 20px;
          color: #ffffff;
          line-height: 24px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          b {
            width: 15px;
            text-align: center;
            font-family: Geometr706 BlkCn BT;
            font-weight: 900;
            font-size: 24px;
            color: #00c9ff;
            font-style: italic;
            background: linear-gradient(0deg, #ffffff 0%, #baf0ff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-right: 32px;
          }
        }
        .item-c {
          width: 63px;
          height: 20px;
          padding: 0 13px;
          background: rgba(252, 245, 194, 0.2);
          border-radius: 2px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 20px;
          color: #fcf5c2;
          line-height: 20px;
        }
        .item-r {
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 20px;
          color: #dcdcdc;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          i {
            font-family: Geometr706 BlkCn BT;
            font-size: 20px;
            color: #dcdcdc;
            font-style: normal;
            margin-right: 11px;
          }
        }
      }
    }
  }
  .l3-2 {
    display: flex;
    flex-direction: column;
    width: 100%;
    width: 984px;
    height: 429px;
    padding: 22px 31px 0 33px;
    box-sizing: border-box;
    background: url('~img/market/market-error.png') no-repeat;
    background-size: 100% 100%;
    .top-box {
      padding-top: 40px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: PingFang SC;
      font-weight: 600;
      font-size: 23px;
      color: #ffffff;
      // line-height: 23px;
      margin-bottom: 5px;
      text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.5);
      i {
        width: 29px;
        height: 31px;
        display: inline-block;
        margin-right: 21px;
        background: url('~img/market/market-error-icon.png') no-repeat;
        background-size: 100% 100%;
      }
      b {
        font-family: 'YouSheTitle';
        font-weight: 400;
        font-size: 38px;
        color: #ffffff;
        margin-left: 51px;
        // text-shadow: 0px 8px 10px rgba(1, 24, 33, 0.7);
        background: linear-gradient(0deg, #c7080a 5.8837890625%, #ffa3a3 67.59765625%, #ffcdcd 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .list-box {
      flex: 1;
      padding-top: 10px;
      padding-left: 10px;
      padding-right: 10px;
      .list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 1px;
        height: 30px;
        padding-top: 60px;
        div {
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 20px;
          color: #e3e3e3;
          line-height: 30px;
          text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
        }
        b {
          font-family: Geometr706 BlkCn BT;
          font-weight: 900;
          font-size: 23px;
          color: #ffffff;
        }
      }
    }
  }
  .chart-content {
    position: relative;
    flex: 1;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    margin-top: 5px;
    padding: 56px 0 0 17px;
    // border: NaNpx solid;
    border-image: linear-gradient(180deg, #071322, #225087) 10 10;
    background: linear-gradient(90deg, rgba(6, 17, 29, 0) 0%, rgba(58, 90, 127, 0.208) 44%, rgba(6, 17, 29, 0) 100%);
    border-radius: 4px;
  }
  /deep/ .po {
    margin: 0;
    height: 0;
    .list {
      position: absolute;
      top: 12px;
      left: 19px;
      right: unset;
    }
  }
  .chart-statistics {
    position: relative;
    background: rgba(1, 20, 48, 0.08);
    border: 2px solid rgba(#095194, 0.2);
    padding: 17px 91px 13px 29px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    i {
      position: absolute;
      top: 0;
      left: 0;
      width: 9px;
      height: 4px;
      background: #7af0fc;
      &.i2 {
        left: 14px;
        opacity: 0.6;
        &.r {
          right: 14px;
        }
      }
      &.i3 {
        left: 27px;
        opacity: 0.2;
        &.r {
          right: 27px;
        }
      }
      &.r {
        left: unset;
        right: 0;
      }
    }
    .item-title {
      position: relative;
      height: 21px;
      perspective: 50px;
      &::after {
        position: absolute;
        left: 0;
        bottom: 0;
        content: attr(data-title);
        font-size: 18px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #eff0f1;
        line-height: 24px;
        padding-left: 10px;
        white-space: nowrap;
      }
      &::before {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 211px;
        height: 20px;
        background: linear-gradient(90deg, #328cbb 0%, rgba(50, 140, 187, 0.5) 10%, transparent 100%);
        content: '';
        display: block;
        transform: rotateX(24deg);
        perspective-origin: right top;
      }
    }
    .span-label,
    .span-num {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      margin-right: 19px;
    }
    .span-num {
      color: #ff6a6a;
      margin-right: 0;
    }
    .stat-left .span-num {
      padding-left: 44px;
      font-size: 24px;
      font-weight: 900;
      color: #6acbff;
      line-height: 38px;
    }
    .span-unit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #eff0f1;
      line-height: 29px;
      opacity: 0.6;
      margin-left: 10px;
    }
    .div-i {
      width: 16px;
      height: 16px;
      margin-right: 9px;
      display: inline-block;
      background: url('~img/commonImg/chart-stat.png') no-repeat;
      background-size: 100% 100%;
    }
    .stat-center,
    .stat-right {
      display: inline-flex;
      align-items: center;
      &.des {
        .div-i {
          transform: rotate(180deg);
        }
        .span-num {
          color: rgba(88, 236, 172, 1);
        }
      }
    }
  }
  .sub-title {
    height: 28px;
    padding: 14px 0 13px 13px;
    font-size: 23px;
    color: #eff0f1;
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    &::before {
      width: 100%;
      height: 18px;
      content: ' ';
      display: block;
      position: absolute;
      bottom: 13px;
      left: 9px;
      background: linear-gradient(90deg, rgba(#0083ad, 1) 0%, rgba(#0083ad, 0) 40%);
      z-index: -1;
      transform: skewX(-40deg);
    }
    &.error::before {
      background: linear-gradient(90deg, rgba(#ff806b, 1) 0%, rgba(#ff806b, 0) 40%);
    }
    // &::after {
    //   width: 0;
    //   height: 0;
    //   content: ' ';
    //   display: block;
    //   position: absolute;
    //   position: absolute;
    //   bottom: 20px;
    //   left: 10px;
    //   border: 20px solid transparent;
    //   border-left-color: #000;
    // }
    span {
      // padding-left: 20px;
      line-height: 1;
      font-size: 23px;
    }
    div {
      display: inline-flex;
      line-height: 1;
      align-items: center;
    }
    #btn-link {
      margin-left: 12px;
    }
  }
  .chart-con {
    //flex: 1;
    //height: 198px;
    /deep/ .echarts > div {
      max-height: 100%;
      canvas {
        height: 100% !important;
      }
    }
  }
  .left-bottom {
    display: flex;
    > div {
      width: calc(50% - 13px);
      &:first-of-type {
        margin-right: 26px;
      }
      /deep/ .title {
        white-space: nowrap;
        width: 100%;
        #btn-link {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      /deep/ .flex-between {
        height: 52px;
      }
    }
  }
  /deep/ .ele-dialog {
    z-index: 9999;
    &.info-modal {
      z-index: 999;
      .item-title {
        position: relative;
        perspective: 100px;
        margin-bottom: 28px;
        height: 25px;
        &::after {
          position: absolute;
          left: 0;
          bottom: 0;
          content: attr(data-title);
          font-size: 18px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #eff0f1;
          line-height: 24px;
          padding-left: 10px;
        }
        &.YouSheTitle::after {
          font-family: 'YouSheTitle';
          font-weight: 400;
          font-size: 26px;
        }
        &::before {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 20px;
          background: linear-gradient(90deg, #328cbb 0%, rgba(50, 140, 187, 0.5) 10%, transparent 100%);
          content: '';
          display: block;
          transform: rotateX(8deg);
          perspective-origin: right top;
        }
      }

      .item-content {
        width: 100%;
        height: auto !important;
        align-items: flex-start;
        box-sizing: border-box;
        border-image: linear-gradient(180deg, #071322, #225087) 10 10;
        // background: linear-gradient(
        //   90deg,
        //   rgba(38, 69, 103, 0.4) 0%,
        //   rgba(61, 110, 167, 0.4) 47%,
        //   rgba(38, 69, 103, 0.4) 100%
        // );
        border-radius: 4px;
        margin-bottom: 41px;
        padding: 23px 20px 31px 41px;
        ul.content-ul {
          padding: 0;
          margin: 0;
          list-style: none;
          max-width: calc(100% / 3);

          + ul {
            position: relative;
            padding-left: 43px;
            &::before {
              position: absolute;
              left: 0;
              top: 0;
              width: 2px;
              height: 100%;
              background: #2c4c73;
              box-shadow: 1px 0px 2px 0px rgba(20, 34, 51, 0.5);
              content: '';
              display: inline-block;
            }
          }
          li {
            display: flex;
          }
          .li-label {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #dcdcdc;
            line-height: 30px;
            margin-right: 22px;
            text-wrap: nowrap;
          }
          .li-value {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
            line-height: 30px;
          }
        }
      }
    }

    &.company-profile .el-dialog {
      width: 2144px;
      height: 806px;
      .el-dialog__body {
        padding: 0;
        height: calc(100% - 55px);
        .item-content {
          // padding: 0;
        }
      }
    }
    .element-select.middle .el-select {
      width: unset;
    }
  }
}
</style>
